// src/App.js
import React, { useState, useEffect } from 'react';
import useDynamicMeta from './hooks/useDynamicMeta';
import AnnouncementBar from './AnnouncementBar';
import Navbar from './Navbar';
import Top from './Top';
import Features from './Features';
import InfoBlocks from './InfoBlocks';
import Reviews from './Reviews';
import Pricing from './Pricing';
import PrivateLogin from './PrivateLogin';
import Dashboard from './Dashboard';
import Footer from './Footer';
import ToS from './ToS';
import './App.css';

// Gibt für jede Hash-Route Titel, Description und Social‑Image zurück
function getMetaForHash(hash) {
  switch (hash) {
    case '#private-login':
      return {
        title: 'EAGLE SCRIPT - Private Login',
        description: 'Secure login for EAGLE SCRIPT users. Access your private dashboard and settings.',
        image: window.location.origin + '/preview-login.png',
      };
    case '#dashboard':
      return {
        title: 'EAGLE SCRIPT - Your Dashboard',
        description: 'Your personal dashboard for managing EAGLE SCRIPT settings and updates.',
        image: window.location.origin + '/preview-dashboard.png',
      };
    default:
      return {
        title: 'Rust Script | Undetected Rust No Recoil Script',
        description:
          'Boost your Rust gameplay with EAGLE SCRIPT – the undetected no‑recoil solution: 100% secure, fully customizable, cloud hotkeys, Anti‑AFK, frequent updates & 24/7 Discord support.',
        image: window.location.origin + '/social-preview.png',
      };
  }
}

function App() {
  const [hash, setHash] = useState(window.location.hash || '');

  useEffect(() => {
    const onHashChange = () => setHash(window.location.hash);
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);

  const { title, description, image } = getMetaForHash(hash);
  const canonicalUrl =
    window.location.origin + window.location.pathname + (hash || '');
  useDynamicMeta({ title, description, canonicalUrl, image });

  return (
    <div className="App">
      <AnnouncementBar />
      {hash !== '#private-login' && hash !== '#dashboard' && hash !== '#Tos' && <Navbar />}

      {hash === '#private-login' ? (
        <PrivateLogin />
      ) : hash === '#dashboard' ? (
        <Dashboard />
      ) : hash === '#Tos' ? (
        <ToS />
      ) : (
        <>
          <div className="top-wrapper">
            <div className="top-shadow" />
            <Top />
          </div>
          <Features />
          <InfoBlocks />
          <Reviews />
          <Pricing />
        </>
      )}

      {hash !== '#private-login' && hash !== '#dashboard' && hash !== '#Tos' && <Footer />}
    </div>
  );
}

export default App;